/**
 * Shared booking notices: a refused booking (409) the customer can act on, and how to pay.
 * Text and amounts come from the booking API (routes/customer-app/booking.js); nothing is computed here.
 */

/**
 * conflict = bookingConflict(err): FEE_CHANGED → accept the new fee or pick another time;
 * SLOT_TAKEN / PROFESSIONAL_BUSY → pick another time.
 */
export function BookingConflictPanel({ conflict, money, busy, onAcceptFee, onPickAnother }) {
  if (!conflict) return null
  const feeChanged = conflict.code === 'FEE_CHANGED' && conflict.callOutFee != null
  return (
    <div role="alert" className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-4 space-y-3">
      <p className="text-sm font-medium text-slate-900">{conflict.message}</p>
      <div className="flex flex-col sm:flex-row gap-2">
        {feeChanged && (
          <button
            onClick={onAcceptFee}
            disabled={busy}
            className="flex-1 py-2.5 px-4 rounded-xl bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 disabled:opacity-50 touch-manipulation"
          >
            {busy ? 'Booking…' : `Book at ${money(conflict.callOutFee, { currency: conflict.currency })}`}
          </button>
        )}
        <button
          onClick={onPickAnother}
          disabled={busy}
          className="flex-1 py-2.5 px-4 rounded-xl border border-slate-300 text-slate-700 text-sm font-medium hover:bg-slate-50 disabled:opacity-50 touch-manipulation"
        >
          Pick another time
        </button>
      </div>
    </div>
  )
}

/** Payment instructions from the server (services/payments.js paymentInstructions); hidden when not set */
export function PaymentInstructions({ text, className = '' }) {
  if (!text) return null
  return (
    <div className={`bg-emerald-50 rounded-2xl p-4 ${className}`}>
      <div className="font-medium text-slate-900 mb-1">How to pay</div>
      <p className="text-sm text-slate-700">{text}</p>
    </div>
  )
}
